// https://www.npmjs.com/package/react-responsive-carousel
import React from "react";
import { newContextComponents } from "@drizzle/react-components";
import { Carousel } from 'react-responsive-carousel';

import "react-responsive-carousel/lib/styles/carousel.min.css";

const { AccountData, ContractData, ContractForm } = newContextComponents;

class CarouselVideos extends React.Component {
  state = { dataKey: null };

  render() {
    return (
        <div className="carousel-wrapper">
          <div>
                <iframe width="560" height="315" src="https://www.youtube.com/embed/k8ibg9UYa68" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                </div>
                <div>
                <iframe width="560" height="315" src="https://www.youtube.com/embed/Nw2BAVcfZSI" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                </div>
                <div>
                <iframe width="560" height="315" src="https://www.youtube.com/embed/MPVHPgyYmj0" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                </div>
            <div>
                <iframe width="560" height="315" src="https://www.youtube.com/embed/B1X0AMONr34" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                </div>
                <div>
                <iframe width="560" height="315" src="https://www.youtube.com/embed/S0hGBo4uIVU" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                </div>

                <div>
                <iframe width="560" height="315" src="https://www.youtube.com/embed/ZnmHIvjOYVk" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                </div>

                <div>
                <iframe width="560" height="315" src="https://www.youtube.com/embed/00tAQPiK76I" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                </div>
            
        </div>
    );
  }
};

export default CarouselVideos;